import { render } from "./PartnersByTypeOfCollaborationChart.vue?vue&type=template&id=4e4efb28&scoped=true"
import script from "./PartnersByTypeOfCollaborationChart.vue?vue&type=script&lang=js"
export * from "./PartnersByTypeOfCollaborationChart.vue?vue&type=script&lang=js"

import "./PartnersByTypeOfCollaborationChart.vue?vue&type=style&index=0&id=4e4efb28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e4efb28"

export default script